import React, { useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";

interface ClientShowerBarProps {
  ClientName: string;
  Folders: string[];
  onClientNameClick: (clientName: string, folder: string) => void;
  onSelectionChange: () => void;
  isActive: boolean;
  index: number;
  Company_id: string;
}

export const ClientShowerBar: React.FC<ClientShowerBarProps> = ({
  ClientName,
  Company_id,
  Folders,
  onClientNameClick,
  onSelectionChange,
  isActive = false,
  index,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeFolder, setActiveFolder] = useState("");

  const handleClientClick = () => {
    if (!isExpanded && isActive) {
      onClientNameClick(Company_id, activeFolder);
    } else {
      onSelectionChange();
      onClientNameClick(Company_id, "");
    }
    setIsExpanded(!isExpanded);
  };

  const handleFolderClick = (folder: string) => {
    setActiveFolder(folder);
    onSelectionChange();
    onClientNameClick(Company_id, folder);
  };

  useEffect(() => {
    if (!isActive) {
      setActiveFolder("");
      setIsExpanded(false);
    }
  }, [isActive]);

  if (!ClientName) {
    return null;
  }

  return (
    <Container
      key={index}
      sx={{
        width: "100%",
        borderBottom: "0.3px solid rgba(255, 255, 255, 0.3)",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
      }}
    >
      <Typography
        variant="h2"
        onClick={handleClientClick}
        sx={{
          fontFamily: "Montserrat",
          fontSize: "1rem",
          lineHeight: "1.375rem",
          fontWeight: isActive ? 700 : 600,
          color: "#FFFFFF",
          padding: "0.75rem",
          margin: 0,
          cursor: "pointer",
          transition: "all 0.2s ease",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "clip",
          width: "100%",
          "&:hover": {
            fontWeight: 700,
            backgroundColor: "rgba(255, 255, 255, 0.05)",
          },
        }}
      >
        {ClientName}
        <Box
          component="span"
          sx={{
            fontSize: "0.75rem",
            marginRight: "1rem",
            transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.2s ease",
            opacity: 0.7,
            display: "inline-block",
          }}
        >
          ▼
        </Box>
      </Typography>
      {isExpanded && (
        <Box
          key={ClientName}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginTop: "0.5rem",
            paddingBottom: "0.5rem",
            width: "90%",
          }}
        >
          {Folders.sort().map((folder) => (
            <Typography
              component="span"
              onClick={() => handleFolderClick(folder)}
              sx={{
                fontFamily: "Montserrat",
                width: "90%",
                fontSize: "1rem",
                fontWeight: folder === activeFolder ? 700 : 500,
                color: "#FFFFFF",
                paddingLeft: "15%",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  fontWeight: 700,
                },
              }}
            >
              {folder}
            </Typography>
          ))}
        </Box>
      )}
    </Container>
  );
};
